export function contactBubble() {
	const wrapper = document.querySelector('[data-contact-bubble]')

	if (!wrapper) return

	const observer = new IntersectionObserver(
		([entry]) => {
			// stick as soon as the bubble scrolls into view, not only once it has passed the top edge
			wrapper.classList.toggle('is-stuck', entry.isIntersecting || entry.boundingClientRect.top < 0)
		},
		{ threshold: 0 }
	)

	observer.observe(wrapper)

	const form = document.querySelector('.section--form')

	if (form) {
		const formObserver = new IntersectionObserver(([entry]) => wrapper.classList.toggle('is-hidden', entry.isIntersecting), { threshold: 0 })

		formObserver.observe(form)
	}
}
